export const USER_ACCESS_TOKEN_KEY = "shopify-customer-access-token";
export const USER_REFRESH_TOKEN_KEY = "shopify-customer-refresh-token";
export const OAUTH_CODE_VERIFIER_KEY = "shopify-oauth-code-verifier";
export const OAUTH_STATE_KEY = "shopify-oauth-state";
export const OAUTH_NONCE_KEY = "shopify-oauth-nonce";
export const LANGUAGE_KEY = "language";
